import React from 'react';

const VehicleAssignmentTableComponentLoadable = React.lazy(() => import('./VehicleAssignmentTableComponent'));

export {
    VehicleAssignmentTableComponentLoadable, 
};